import Vue from 'vue';
import Vuex from 'vuex';

import mutations from './trip.mutations';
import actions from './trip.actions';

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    trips: []
  },
  mutations,
  actions
};
